import { FormErrorList } from './FormErrorList'
import { Trans } from '@lingui/macro'

/**
 * Component displaying placeholder errors to show what an error list form element looks like.
 * @category Form
 * @subcategory Form elements
 * @component
 * @returns {JSX.Element}
 */
export const FormErrorListPreview = () => {
  const placeholderErrors = [
    {
      elementType: 'textInput',
      error: <Trans>This question is required</Trans>,
      id: '8c83b289a10382eb96635827b49137e8',
      sectionIndex: 0,
      showBasicElements: true,
      title: 'Please provide a brief summary of the project',
    },
    {
      showBasicElements: true,
      error: <Trans>This question is required</Trans>,
      elementType: 'picklist',
      id: '8ceffdebe81e24b7cae19dd632a6df88',
      title:
        'The project increases organizational capacity through training of staff, Board members or volunteers',
      sectionIndex: 0,
    },
    {
      showBasicElements: true,
      elementType: 'textInput',
      error: <Trans>This question is required</Trans>,
      id: 'f4ad7929df34588f640b9c5c0d6d609c',
      title: 'Who will your partners be in this project? ',
      sectionIndex: 0,
    },
  ]

  const navigateToError = () => {}

  return (
    <FormErrorList
      sectionIndex={0}
      errors={placeholderErrors}
      typeProps={{ showAllErrors: true }}
      navigateToError={navigateToError}
    />
  )
}
